import { useQuery, useQueryClient } from 'react-query'
import axios from '../../utils/axios'
import { API_BASE_URL } from '../../constants'

const fetchCarrierAnalysisFileStatus = async (analysisWrapperId) => {
  const { data } = await axios.get(`${API_BASE_URL}/carrier-analysis/${analysisWrapperId}/file-status/`)
  return data
}

export const useCarrierAnalysisFileStatus = (analysisWrapperId, enabled = true) => {
  const queryClient = useQueryClient()

  const query = useQuery(
    ['carrier-analysis-file-status', analysisWrapperId],
    () => fetchCarrierAnalysisFileStatus(analysisWrapperId),
    {
      enabled: enabled && !!analysisWrapperId,
      refetchOnWindowFocus: false,
      staleTime: 1000 * 30, // 30 seconds
      retry: 2,
    },
  )

  const refresh = () => {
    if (analysisWrapperId) {
      queryClient.invalidateQueries(['carrier-analysis-file-status', analysisWrapperId])
    }
  }

  return { query, refresh }
}
